import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const authClientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginClient: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/client/login",
        method: "POST",
        body: client,
      }),
      invalidatesTags: ["Client"],
    }),
    registerClient: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/client/sign-up",
        method: "POST",
        body: client,
      }),
      invalidatesTags: ["Client"],
    }),
    resetPswClient: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/client/resetPassword",
        method: "POST",
        body: client,
      }),
      invalidatesTags: ["Client"],
    }),
    createNewPasswordClient: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/client/createNewPassword",
        method: "POST",
        body: client,
      }),
      invalidatesTags: ["Client"],
    }),
  }),
});

export const {
  useLoginClientMutation,
  useRegisterClientMutation,
  useResetPswClientMutation,
  useCreateNewPasswordClientMutation,
} = authClientApiSlice;
